<script setup lang="ts">
import { computed } from 'vue';
import { Loader2 } from 'lucide-vue-next';

const props = withDefaults(
  defineProps<{
    variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'success';
    size?: 'sm' | 'md';
    type?: 'button' | 'submit';
    loading?: boolean;
    disabled?: boolean;
    block?: boolean;
  }>(),
  { variant: 'primary', size: 'md', type: 'button', loading: false, disabled: false, block: false },
);

const classes = computed(() => [
  'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition disabled:cursor-not-allowed disabled:opacity-60 whitespace-nowrap',
  props.size === 'sm' ? 'px-2.5 py-1.5 text-xs' : 'px-4 py-2 text-sm',
  props.block ? 'w-full' : '',
  {
    primary: 'bg-navy-700 text-white hover:bg-navy-800 shadow-sm',
    secondary: 'surface border text-current hover:bg-slate-50 dark:hover:bg-white/5 shadow-sm',
    ghost: 'text-current hover:bg-slate-100 dark:hover:bg-white/10',
    danger: 'bg-red-600 text-white hover:bg-red-700 shadow-sm',
    success: 'bg-leaf-600 text-white hover:bg-leaf-700 shadow-sm',
  }[props.variant],
]);
</script>

<template>
  <button :type="type" :class="classes" :disabled="disabled || loading">
    <Loader2 v-if="loading" class="h-4 w-4 animate-spin" aria-hidden="true" />
    <slot />
  </button>
</template>
